import { combineReducers } from 'redux';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import global from './global/globalSlice';
import user from './user/userSlice';
import dashboard from './dashboard/dashboardSlice';
import securityDashboard from './securityDashboard/securityDashboardSlice';
import visitRequestForm from './visitRequestForm/visitRequestFormSlice';
import accessRequestForm from './accessRequestForm/accessRequestFormSlice';
import guardingRequestForm from './guardingRequestForm/guardingRequestFormSlice';
import visitRequestReview from './visitRequestReview/visitRequestReviewSlice';
import notification from './notification/notificationSlice';
import sites from './sites/sitesSlice';
import incidents from './incidents/incidentsSlice';
import contacts from './contacts/contactsSlice';
import bookingLinks from './bookingLinks/bookingLinksSlice';
import dailyReports from './dailyReports/dailyReportsSlice';
import featureTour from './featureTour/featureTourSlice';

// User persist config - exclude problematic auth transient states
const userPersistConfig = {
    key: 'user',
    storage,
    blacklist: [
        'isFetching',
        'error',
        'rateLimit',
    ],
};

/**
 * ## CombineReducers
 *
 * the rootReducer will call each and every reducer with the state and action
 * EVERY TIME there is a basic action
 */
const appReducers = combineReducers({
    // ... your other reducers here ...
    global,
    user: persistReducer(userPersistConfig, user),
    dashboard,
    securityDashboard,
    visitRequestForm,
    accessRequestForm,
    guardingRequestForm,
    visitRequestReview,
    notification,
    sites,
    incidents,
    contacts,
    bookingLinks,
    dailyReports,
    // Deliberately NOT blacklisted in store.ts: persisting the step index is
    // what lets a mid-tour page refresh resume where the user left off.
    featureTour,
});
export default appReducers;
